import { textTruncate } from '../../styles/commonStyles';
import SemanticClasses from '../../typings/semantic/semanticClasses';
import CheckBox from '../formItems/checkBox';
import RupTooltip from '../rupTooltip';
import WrappedText from '../wrappedText';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';
import { useState } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			gap: '0.25rem',
			height: '2.25rem',
			fontWeight: '400',
			cursor: 'default',
			overflow: 'hidden'
		},
		rectangle: {
			width: '1rem',
			height: '1rem',
			borderRadius: '0.25rem',
			flexShrink: 0
		},
		vocabularyName: {
			color: Colors.neutral900,
			fontSize: '0.875rem',
			...textTruncate
		}
	})
);

export interface IVocbularyCollapseProps {
	vocabularyName: string;
	collapsed: boolean;
	selected: boolean;
	onCollapseClick?: (collapsed: boolean) => void;
	onVocabularyClick?: () => void;
	tooltip?: string;
}

const VocbularyCollapseHeader: React.FunctionComponent<IVocbularyCollapseProps> = props => {
	const classes = useStyles();
	const [collapsed, setCollapsed] = useState(props.collapsed);

	const onVocabularyClick = () => {
		if (props.onVocabularyClick) {
			props.onVocabularyClick();
		}
	};

	return (
		<div className={classes.root}>
			<button
				style={{ flexShrink: 0 }}
				type="button"
				className="rup-icon-btn rup-icon-btn--neutral rup-icon-btn--xs"
				onClick={() => {
					if (props.onCollapseClick) {
						props.onCollapseClick(!collapsed);
					}

					setCollapsed(!collapsed);
				}}
			>
				<span
					dangerouslySetInnerHTML={{ __html: collapsed ? Icons.ChevronRightIcon : Icons.ChevronDownIcon }}
				/>
			</button>
			<div className={classes.root}>
				<CheckBox checked={props.selected} onChange={onVocabularyClick} />
				<div className={clsx(classes.rectangle, SemanticClasses.vocabularyRectangle)} />
				<WrappedText text={props.vocabularyName} className={classes.vocabularyName} />
				{props.tooltip && (
					<RupTooltip title={props.tooltip} sx={{ maxWidth: '14rem' }} placement="bottom" arrow>
						<span className="rup-icon rup-icon--sm" dangerouslySetInnerHTML={{ __html: Icons.InfoIcon }} />
					</RupTooltip>
				)}
			</div>
		</div>
	);
};

export default VocbularyCollapseHeader;
